<div
  class="flex flex-col gap-6 p-6 items-center text-center bg-white rounded-lg border-none outline-none"
>
  <div
    class="mt-3 w-14 h-14 rounded-full bg-blue-50 flex items-center justify-center animate-bounce-slow"
  >
    <i class="pi pi-search text-3xl text-primary-500"></i>
  </div>

  <div class="flex flex-col gap-2 items-center">
    <h3 class="text-xl font-bold text-gray-800 m-0">New Vessel Found</h3>
    <p class="text-gray-500 m-0 text-sm leading-relaxed">
      <span class="font-semibold text-gray-700">{{ vesselName }}</span>
      <span *ngIf="imo"> (IMO {{ imo }})</span>
      was found on VesselFinder! 🎉 
    </p>
    <p class="text-gray-500 m-0 text-sm leading-relaxed">Would you like to <strong>save it</strong> in the system?</p>
  </div>

  <div class="flex gap-3 w-full mt-2 text-sm">
    <button
      pButton
      type="button"
      label="No, just use the data in this quote"
      class="p-button-outlined p-button-secondary w-full font-bold justify-center border border-gray-300 text-gray-600 hover:bg-gray-50 transition-colors duration-200 py-3"
      (click)="ref.close(false)"
    ></button>

    <button
      pButton
      type="button"
      label="Yes, save it"
      iconPos="right"
      icon="pi pi-save"
      class="w-full font-bold justify-center !border-none !text-white transition-colors duration-200 py-3 shadow-sm"
      [style]="{ 'background-color': 'var(--primary-500)' }"
      (click)="ref.close(true)"
    ></button>
  </div>
</div>
